import { CareTeamV3 } from '@/utils/types';

export default {
  setCareTeam: (payload: CareTeamV3) =>
    ({ type: 'careTeamV3/setCareTeam', payload }) as const,
};
